import { tokenStore } from './tokenStore';

export const API_BASE = 'https://api.gate.haus';

export async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers
  };

  const accessToken = tokenStore.get();
  if (accessToken) {
    (headers as Record<string, string>)['X-Access-Token'] = accessToken;
  }

  if (options.body instanceof FormData) {
    delete (headers as Record<string, string>)['Content-Type'];
  }

  const url = new URL(`${API_BASE}${path}`);

  const response = await fetch(url.toString(), {
    ...options,
    headers,
    credentials: 'include'
  });

  if (!response.ok) {
    const errorBody = await safeParse(response);
    throw new Error(errorBody?.error || errorBody?.message || 'Request failed');
  }

  return response.json() as Promise<T>;
}

async function safeParse(response: Response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
